module.exports = __webpack_public_path__ + "static/media/eve.be11eb94.svg";